import { createSlice } from "@reduxjs/toolkit";
import getMicroscopyMeasurements from '../../../rtk-apis/microscopy/getMeasurements'

const initialState = {
  status: "",
  result: [],
  message: "",
  loading: false,
  error: ""
};

const getMicroscopyMeasurementsSlice = createSlice({
  name: "patientMicroscopicData",
  initialState,
  reducers: {
    resetStatus(state: any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMicroscopyMeasurements.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(getMicroscopyMeasurements.fulfilled, (state, { payload }) => {
        console.log("Fulfilled", payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getMicroscopyMeasurements.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getMicroscopyMeasurementsSlice.reducer;
export const { resetStatus } = getMicroscopyMeasurementsSlice.actions;
